import gql from "graphql-tag";

export default gql`
  query schoolOrDistrictRegistration($registrationId: ID!) {
    schoolOrDistrictRegistration(id: $registrationId) {
      id
      ncesSchoolId
      ncesDistrictId
      numberOfSchools
      districtName
      contactPhoneNumber
      status
      registrant {
        firstName
        lastName
        email
      }
      setupProgress {
        areSchoolsActivated
        schoolsActivatedAt
        isSiteLinked
        siteLinked
        siteLinkedAt
        haveStaffBeenLoaded
        staffLoadedAt
        haveStaffBeenEmailed
        staffEmailedAt
        haveStaffBeenTrained
        staffTrainedAt
        haveOrgsBeenEmailed
        orgsEmailed
        orgsEmailedAt
        haveParentsBeenLoaded
        parentsLoadedAt
        haveParentsBeenEmailed
        parentsEmailed
        parentsEmailedAt
        status
        createdAt
        updatedAt
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/gql/schoolOrDistrictRegistration.query.js